import cx from 'classnames'
import { useEffect } from 'react'

import { MenuOption } from 'components/Menu'
import { useModal } from 'store/slices/modals'

import './style'

export type ActionSheetMenuOption = MenuOption & {
  iconPath: string
  isDestructiveAction?: boolean
}

type ActionSheetModalProps = {
  menu?: ActionSheetMenuOption[]
}

export const useActionSheetModal = () =>
  useModal<ActionSheetModalProps>('ActionSheetModal')

export const ActionSheetModal = () => {
  const { isActive, onClose, data = {} } = useActionSheetModal()
  const { menu } = data

  useEffect(() => {
    if (isActive && !menu?.length) onClose()
  }, [menu, isActive])

  return (
    <div
      className={cx('Modal ActionSheetModal', {
        'Modal--active': isActive,
      })}
    >
      <a className="Modal__overlay" onClick={() => onClose()} />

      <div className="ActionSheetModal">
        <div className="ActionSheetModal__menu">
          {menu?.map((m, i) => (
            <div
              key={i}
              className={cx('ActionSheetModal__menu__item', {
                'ActionSheetModal__menu__item--red': m.isDestructiveAction,
              })}
              onClick={() => {
                m.onClick?.()
                onClose()
              }}
            >
              <img
                className="ActionSheetModal__menu__item__icon"
                src={m.iconPath}
                alt={m.title.toString()}
              />
              {m.title}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
